import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NavController, NavParams, ViewController} from 'ionic-angular';

@Component({
  selector: 'page-select-download',
  templateUrl: 'select-download.html'
})
export class SelectDownloadModal {
  protected week: number;
  protected type: string;
  protected formGroupWeek: FormGroup;

  constructor(public navCtrl: NavController, public navParams: NavParams, private viewCtrl: ViewController, private formBuilder: FormBuilder,) {
    this.week = navParams.get('week');
    this.type = navParams.get('type');
    this.formGroupWeek = this.formBuilder.group({
      weekNumber: [[this.week]],
      oneWeek: [[true]]
    });
    setTimeout(() => {
      this.formGroupWeek.reset({
        weekNumber: this.week,
        oneWeek: true
      });
    });
  }

  dismiss() {
    this.viewCtrl.dismiss({
      week: this.formGroupWeek.get('weekNumber').value,
      oneWeek: this.formGroupWeek.get('oneWeek').value
    });
  }

  cancel() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/modals/select-download/select-download.ts